import type {
    DateDimensionConfiguration,
    DateDimensionProps,
} from "../../components/dimensions/DateDimension";
import { DateType } from "../../components/dimensions/DateDimensionHelpers";
import { DimensionTypes } from "../../types/dimensions";

import type { DimensionFixtureExample } from ".";

export const dataDimensionConfiguration: Record<
    string,
    DateDimensionConfiguration
> = {
    basic: {
        label: "basic date",
    },
    absolute: {
        label: "basic date",
        startDate: {
            type: DateType.ABSOLUTE,
            dateString: "2025-01-25",
        },
    },
    absoluteEndDate: {
        label: "basic date",
        endDate: {
            type: DateType.ABSOLUTE,
            dateString: "2025-01-25",
        },
    },
};

export const dateDimensionProps: Record<string, DateDimensionProps> = {
    basic: {
        id: "date-basic",
        type: DimensionTypes.DATE,
        configuration: dataDimensionConfiguration.basic,
        dependencies: [],
        optional: false,
    },
    absolute: {
        id: "date-absolute",
        type: DimensionTypes.DATE,
        configuration: dataDimensionConfiguration.absolute,
        dependencies: [],
        optional: false,
    },
    absoluteEndDate: {
        id: "date-absolute-end-date",
        type: DimensionTypes.DATE,
        configuration: dataDimensionConfiguration.absoluteEndDate,
        dependencies: [],
        optional: false,
    },
};

export const dateDimensionExamples: Record<string, DimensionFixtureExample> = {
    basic: {
        id: "date-basic",
        name: "date dimension - basic",
        description: "date dimension - basic",
        dimensions: [[dateDimensionProps.basic]],
    },
    absolute: {
        id: "date-absolute",
        name: "date dimension - absolute",
        description: "date dimension - absolute",
        dimensions: [[dateDimensionProps.absolute]],
    },
};
